import React from 'react'
import Main from './Components//Main/Main'

import { SelectedCardProvider } from "./Context/SelectedCardContext";


function App() {
  return (
    <div>
       <SelectedCardProvider>
      <Main></Main>
    </SelectedCardProvider>
    </div>
  )
}

export default App